export default __webpack_public_path__ + "static/media/card-w-service@2x.52d60454.png";